import { Landing } from 'modules/landings-info/landings-info-types';
import { ServiceCategory } from 'modules/service-categories/service-categories-types';
import { PROJECTS_IMAGES_DATA } from './construction-houses-projects-section-constants';

export type ProjectStructure = {
  projectName: string;
  projectUrl: string;
  projectImage: string | undefined;
};

/**
 * Возвращает данные для блока "Наши проекты"
 * @param {string[]} projects
 * @param {Landing[] | undefined} landingsList
 * @param {ServiceCategory[] | null} serviceCategoriesList
 */
export const getFinalProjectsData = (
  projects: string[],
  landingsList: Landing[] | null,
  serviceCategoriesList: ServiceCategory[] | null
) =>
  projects.reduce((res: ProjectStructure[], projectId: string) => {
    if (
      landingsList?.some(landing => landing.landingName === projectId) ||
      serviceCategoriesList?.some(service => service.topCategoryId.toString() === projectId)
    ) {
      const projectData =
        landingsList?.find(landing => landing.landingName === projectId) ||
        serviceCategoriesList?.find(
          serviceCategory => serviceCategory.topCategoryId.toString() === projectId
        );
      const projectOtherData = PROJECTS_IMAGES_DATA.find(imageData => imageData.serviceId === projectId);
      const projectCommonData: ProjectStructure = {
        projectName:
          (projectData as Landing).defaultTitle || (projectData as ServiceCategory).topCategoryName,
        projectUrl: (projectData as Landing).url || (projectData as ServiceCategory).topCategoryUrl,
        projectImage: projectOtherData?.imgSrc || undefined,
      };
      res.push(projectCommonData);
    }
    return res;
  }, []);
